import React from 'react';
import { MarketingSiteContext } from '../../context';
import {
  MarketingSiteDataType,
  LandingPageEntity,
} from '../../store/landing/types';
import { INITIAL_LANDING_PAGE_DATA, PublicSitePages } from '../../constants';
import UnauthApp from './UnauthApp';
import { useInitApp } from './useInitApp';

interface MarketingSiteProps {
  context: {
    pathname: string;
    query: Record<string, any>;
    isMobile: boolean;
    portalConfig: any;
    marketingSiteData?: MarketingSiteDataType;
  };
}

const MarketingSite: React.FC<MarketingSiteProps> = ({ context, children }) => {
  // NOTE: If you need to add or modify header, footer etc. of the app,
  // please do that inside the Layout component.
  const { marketingSiteData = { pages: [], showBadge: false } } = context;
  const { pages, ...config } = marketingSiteData;

  useInitApp();

  const marketingSiteEntities = React.useMemo(
    () => ({
      config,
      pages: {
        home:
          pages.find(
            pageEntity =>
              pageEntity.fields.pageEntityType === PublicSitePages.Home,
          ) || (INITIAL_LANDING_PAGE_DATA.home as LandingPageEntity),
        team:
          pages.find(
            pageEntity =>
              pageEntity.fields.pageEntityType === PublicSitePages.Team,
          ) || (INITIAL_LANDING_PAGE_DATA.team as LandingPageEntity),
        aboutUs:
          pages.find(
            pageEntity =>
              pageEntity.fields.pageEntityType === PublicSitePages.About,
          ) || (INITIAL_LANDING_PAGE_DATA.aboutUs as LandingPageEntity),
        contactUs:
          pages.find(
            pageEntity =>
              pageEntity.fields.pageEntityType === PublicSitePages.Contact,
          ) || (INITIAL_LANDING_PAGE_DATA.contactUs as LandingPageEntity),
        pricing:
          pages.find(
            pageEntity =>
              pageEntity.fields.pageEntityType === PublicSitePages.Pricing,
          ) || (INITIAL_LANDING_PAGE_DATA.pricing as LandingPageEntity),
      },
    }),
    [pages, config],
  );

  return (
    <MarketingSiteContext.Provider value={marketingSiteEntities}>
      <UnauthApp context={context}>{children}</UnauthApp>
    </MarketingSiteContext.Provider>
  );
};

export default MarketingSite;
